import { Component, input } from "@angular/core";

@Component({
  selector: "tabbed-card",
  standalone: false,
  templateUrl: "./tabbed-card.component.html",
  styleUrl: "./tabbed-card.component.scss",
})
export class TabbedCardComponent {
  public tabData = input.required<any[]>();
  public cardClass = input<any[]>();
}
